import React from 'react';
import CurrentTimeSelector from './CurrentTimeSelector';
import { CUTOFF_HOUR, MIN_HOURS_BEFORE_PICKUP } from "@/lib/datetime-utils";
interface TestTimeControlsProps {
  showTestControls: boolean;
  onToggle: () => void;
  currentTime: Date;
  onTimeChange: (time: Date) => void;
}
const TestTimeControls: React.FC<TestTimeControlsProps> = ({
  showTestControls,
  onToggle,
  currentTime,
  onTimeChange
}) => {
  return <div className="mb-4">
      <button onClick={onToggle} className="text-xs text-blue-500 hover:underline mb-2">
        {showTestControls ? "Hide Test Controls" : "Show Test Controls"}
      </button>
      
      {showTestControls && <CurrentTimeSelector currentTime={currentTime} onTimeChange={onTimeChange} />}
      
      {showTestControls && <div className="mt-2 p-2 rounded-md text-xs text-gray-700 border border-green-200 bg-transparent">
          <p className="font-medium">Time Rules:</p>
          <ul className="list-disc pl-5 mt-1">
            <li>Today is disabled after {CUTOFF_HOUR}:00 (2 PM)</li>
            <li>Time slots are disabled if they're in the past</li>
            <li>Time slots are disabled if they're less than {MIN_HOURS_BEFORE_PICKUP} hour from now</li>
          </ul>
        </div>}
    </div>;
};
export default TestTimeControls;